/* eslint-disable eqeqeq */
import { useEffect, useRef, useState } from "react";
import { axiosPrivate } from "../../../Apis/axios";
import Update from "./Update";
import $ from 'jquery';
import Delete from "./Delete";
import Create from "./Create";
import useAuth from "../../../Hooks/useAuth";
$.DataTable = require('datatables.net-bs5');


function Table() {

  const { auth } = useAuth();
  const tableRef = useRef()
  const tableName = "table-booking"
  const url = "/bookings";

  const [data, setData] = useState();
  const [properties, setProperties] = useState();
  const [organisations, setOrganisations] = useState();
  const [paymentMethods, setPaymentMethods] = useState();
  const [updateId, setUpdateId] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  // const [updateTitle, setUpdateTitle] = useState("");
  // const [updateIcon, setUpdateIcon] = useState("");
  // const [updateDescription, setUpdateDescription] = useState("");

  let actions = `<button class="btn edit-btn" data-toggle="modal" data-target="#bookingUpdateModal" ><i class="ti-pencil text-primary" ></i> </button> <b> - </b>                          
                  <button class="btn delete-btn" data-toggle="modal" data-target="#bookingDeleteModal"><i class="ti-trash text-danger"></i> </button>`;
  if(auth.roleId == 2){
    actions = `<button class="btn edit-btn" data-toggle="modal" data-target="#bookingUpdateModal" ><i class="ti-pencil text-primary" ></i> </button>`;
  }

  const columns =  [
      { title: "ID"},
      { title: "Prop."},
      { title: "Room"},
      { title: "Res."},
      { title: "Type"},
      { title: "Price"},
      { title: "Comm."},
      { title: "Add."},
      { title: "Qty."},
      { title: "Tot."},
      { title: "DOA"},
      { title: "DOD"},
      { title: "Status"},
      { title: "Actions"},
  ];

  async function getAll(){
    try{
      // Axios API.
      const response = await axiosPrivate.get(url);
      const properties = await axiosPrivate.get("/properties");
      const organisations = await axiosPrivate.get("/organisations");
      const paymentMethods = await axiosPrivate.get("/payments");

      // Print Out Responses.
       //console.log(response);

      // Set Data.
      const formatedData = await response?.data?.map((booking) => {

        if(auth.roleId == 2){
          if(booking.Room.Property.userId === auth.userId) {
            return [
              booking?.id,
              booking?.Room?.Property?.name || " - ",
              booking?.Room?.roomType || " - ",
              (booking?.User?.firstName || " - ")+" "+(booking?.User?.lastName || " - "),
              booking?.type,
              "₦"+booking?.price,
              "₦"+booking?.commission,
              "₦"+booking?.markup,
              booking?.quantity,
              "₦"+booking?.totalAmount,
              booking?.arrivalDate,
              booking?.departureDate,
              booking?.status,
            ]
          }
          return false;
        }else{
          return [
            booking.id,
            booking?.Room?.Property?.name || " - ",
            booking?.Room?.roomType || " - ",
            (booking?.User?.firstName+" "+booking?.User?.lastName) || " - ",
            booking?.type,
            "₦"+booking?.price,
            "₦"+booking?.commission,
            "₦"+booking?.markup,
            booking?.quantity,
            "₦"+booking?.totalAmount,
            booking?.arrivalDate,
            booking?.departureDate,
            booking?.status,
          ]
        }
      })

      // console.log(formatedData.filter(function (booking) {
      //   return booking != false;
      // }));

      setData(formatedData?.filter(function (booking) {
        return booking != false;
      }));
      setProperties(properties?.data);
      setOrganisations(organisations?.data);
      setPaymentMethods(paymentMethods?.data);

    }catch(e){
      console.error(e);
    }
  }

  function setUpdateInformation(data){
    setUpdateId(data[0]);
    setUpdateStatus(data[12]);
  }

  function setDeleteInformation(data){
    setUpdateId(data[0]);
  }

  useEffect(() => { getAll() }, []);
  
  const table = $(tableRef.current).DataTable({
    data: data,
    columns: columns,
    dom: "<'d-flex justify-content-between'<B><f>>rt<'d-flex justify-content-between'<l><p>>i<'clear'>",
    pageLength: 5,
    lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, "All"]],
    buttons: [
      // { extend: 'pdf', className: 'btn btn-sm btn-dark' },
      { extend: 'csv', className: 'btn btn-sm btn-dark' },
    ],
    columnDefs: [
      {
        targets: -1,
        data: null,
        render: function () {
          return actions;
        }
      },
    ],
    drawCallback: () => {
      $('.form-control').addClass('form-control-sm');
      $('.active > .page-link').addClass('bg-dark');
    },
    destroy: true,     
  });

  $('#table-booking tbody').on('click', 'tr', function () {
    if ($(this).parent("tr").hasClass('selected')) {
        $(this).removeClass('selected');
    } else {
        table.$("tr.selected").removeClass('selected');
        $(this).addClass('selected');
    }
  });

  $("#table-booking tbody").on("click", "button", function () {
    let data = table.row($(this).parents("tr")).data();
    if(data) setUpdateInformation(data)
    if(data) setDeleteInformation(data)
  });

  return (
    <>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <h4 className="card-title text-danger">All Bookings</h4>
                {auth?.roleId == 1?
                  (<button type="button" className="btn btn-danger btn-sm btn-icon-text" data-toggle="modal" data-target="#bookingModal">
                    <i className="ti-file btn-icon-prepend"></i> Add Booking
                  </button>)
                : (<></>)
                }

              </div>
              <div className="table-responsive pt-3">
                <table className="display table table-striped" width="100%" id={ tableName } ref={ tableRef }></table>
              </div>
            </div>
          </div>
        </div>
        <Create propertyOpt={properties} organisations={organisations} payments={paymentMethods} />
        <Update bookingId={updateId} status={updateStatus} />
        <Delete bookingId={updateId} />
    </>
  );

}
export default Table;